import { useState, useEffect } from "react";
import {
    Box,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    TextField,
    Typography,
    Snackbar,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface Team {
    id: number;
    name: string;
}

export default function Equipas() {
    const [teams, setTeams] = useState<Team[]>([]);
    const [name, setName] = useState("");
    const [editId, setEditId] = useState<number | null>(null);
    const [alert, setAlert] = useState<{ open: boolean; msg: string }>({
        open: false,
        msg: "",
    });

    const load = () =>
        fetch("/team", { credentials: "include" })
            .then((r) => (r.ok ? r.json() : []))
            .then(setTeams);

    useEffect(() => {
        load();
    }, []);

    const save = async () => {
        const url = editId ? `/team/${editId}` : "/team";
        const method = editId ? "PUT" : "POST";
        const res = await fetch(url, {
            method,
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ name }),
        });
        setAlert({ open: true, msg: res.ok ? "Sucesso" : "Erro" });
        setName("");
        setEditId(null);
        load();
    };

    const remove = async (id: number) => {
        await fetch(`/team/${id}`, {
            method: "DELETE",
            credentials: "include",
        });
        setAlert({ open: true, msg: "Eliminado" });
        load();
    };

    const startEdit = (t: Team) => {
        setName(t.name);
        setEditId(t.id);
    };

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Equipas
            </Typography>
            <Box component="form" sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                    fullWidth
                    label="Nome da Equipa"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <Button
                    variant="contained"
                    onClick={save}
                    disabled={!name.trim()}>
                    {editId ? "Atualizar" : "Adicionar"}
                </Button>
            </Box>
            <List>
                {teams.map((t) => (
                    <ListItem key={t.id} divider>
                        <ListItemText primary={t.name} />
                        <ListItemSecondaryAction>
                            <IconButton edge="end" onClick={() => startEdit(t)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton edge="end" onClick={() => remove(t.id)}>
                                <DeleteIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>
            <Snackbar
                open={alert.open}
                onClose={() => setAlert((a) => ({ ...a, open: false }))}
                autoHideDuration={2000}
                message={alert.msg}
            />
        </Box>
    );
}
